import { Component, OnInit, inject } from '@angular/core';
import { PageComponent } from 'src/app/components/pages/page.component';
import { APPLICATION_ROUTES } from 'src/app/constants/application-routes';
import { AdobePageName } from 'src/app/services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from 'src/app/services/adobe-launch/adobe-launch.service';
import { TitleService } from 'src/app/services/title/title.service';

import { ContentUtil } from '../../../../../utils/content/content.util';
import { InterstitialPageContentComponent } from 'src/app/components/interstitial-page-content/interstitial-page-content.component';

@Component({
    selector: 'zci-add-existing-user-page',
    templateUrl: './add-existing-user-page.component.html',
    imports: [
        InterstitialPageContentComponent,
    ],
})
export class AddExistingUserPageComponent extends PageComponent implements OnInit {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private titleService = inject(TitleService);

    content = ContentUtil.content;

    appRoutes = APPLICATION_ROUTES;

    ngOnInit(): void {
        this.titleService.setTitle(this.content.userInterstitialPages.addUser.pageTitle);
        this.adobeLaunchService.pageLoad(AdobePageName.USERS_ADD_ACCESS_PAGE);
    }
}
